import EscapeManager from '../../../js/Managers/EscapeManager.js';

class SelectGroup extends HTMLElement {
  /*container: HTMLDivElement;
  button: HTMLButtonElement;
  buttonText: HTMLSpanElement;
  inputs: NodeListOf<HTMLInputElement>;
  title: string;
  #open: Boolean;*/
  #open = false;
  escapeManagerID = `selectGroup${Math.random().toString(36).substring(2, 15)}`;

  constructor() {
    super();

    this.container = this.querySelector('.select-group__list');
    this.button = this.querySelector('.select-group__button');
    this.buttonText = this.button.querySelector('.button__text');
    this.inputs = this.container.querySelectorAll('input');
    this.type = this.getAttribute('data-select-type');
    this.title = this.button.getAttribute('title');
    this.buttonText.innerHTML = this.title;
    this.parentForm = this.closest('form');

    this._onDocumentClick = this.onDocumentClick.bind(this);
    this._onInputChangeBind = this.onInputChange.bind(this);
    this._onParentFormClearBind = this.onParentFormClear.bind(this);
    this._onButtonClickBind = this.onButtonClick.bind(this);
    this._onKeyboardEscapeBind = this.onKeyboardEscape.bind(this);

    this.onInputChange();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', this._onButtonClickBind);
    this.inputs.forEach(input => {
      input.addEventListener('change', this._onInputChangeBind);
    });
    if (this.parentForm) {
      this.parentForm.addEventListener('clear', this._onParentFormClearBind);
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClickBind);
    this.inputs.forEach(input => {
      input.removeEventListener('change', this._onInputChangeBind);
    });
    if (this.parentForm) {
      this.parentForm.removeEventListener('clear', this._onParentFormClearBind);
    }
  }

  onButtonClick() {
    this.toggle();
  }

  toggle() {
    this.open = !this.open;
  }

  onInputChange() {
    let list = [];
    this.inputs.forEach(input => {
      if (input.checked) {
        list.push(input.title);
      }
    });

    let listText = '';
    if (list.length > 0) {
      listText = list.join(', ');
    }
    this.buttonText.innerHTML = this.title + (listText ? ` <em>${listText}</em>` : '');
    this.button.setAttribute('title', this.title + (listText ? ' (' + listText + ')' : ''));
  }

  #openContainer() {
    this.button.setAttribute('aria-expanded', 'true');
    this.container.removeAttribute('hidden');
    document.addEventListener('click', this._onDocumentClick);
    EscapeManager.add(this.escapeManagerID, this._onKeyboardEscapeBind);
  }

  #closeContainer() {
    this.button.setAttribute('aria-expanded', 'false');
    this.container.setAttribute('hidden', '');
    document.removeEventListener('click', this._onDocumentClick);
    EscapeManager.remove(this.escapeManagerID);
  }

  get open() {
    return this.#open;
  }

  set open(value) {
    if (value === this.#open) return;

    this.#open = value;

    if (this.#open) {
      this.#openContainer();
    } else {
      this.#closeContainer();
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.open = false;
    }
  }
  onParentFormClear() {
    setTimeout(() => {
      this.onInputChange();
    }, 1);
  }

  onKeyboardEscape() {
    if (this.open) {
      this.open = false;
    }
  }
}

customElements.define('select-group', SelectGroup);
